export const handleWidth: IHandleWidth = 
(
  isActive, 
  isTabletHorizzontal, 
  isTablet, 
  isBetweenTabletAndLarge,
  isLarge
) => {
  if(isActive && isTablet) return "100vw";

  if(isActive && isTabletHorizzontal) return "34vw";
  
  if(isLarge) return "33vw";


  if(isBetweenTabletAndLarge) return "38vw";


  return "35vw";
};


type IHandleWidth = (
    isActive: boolean, 
    isTabletHorizzontal: boolean, 
    isTablet:boolean, 
    isBetweenTabletAndLarge:boolean,
    isLarge:boolean
) => string
